export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="lg:w-3/5">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide uppercase mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              Avalia&ccedil;&atilde;o
            </span>

            <blockquote className="mb-8">
              <p className="text-foreground-950 font-heading text-2xl md:text-3xl font-medium leading-relaxed italic">
                &ldquo;O CSSBuy Spreadsheet mudou completamente a forma como importo produtos da China. Antes eu passava horas em f&oacute;runs, hoje encontro tudo em minutos.&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-secondary-200 flex items-center justify-center overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20stylish%20person%20wearing%20a%20warm%20beige%20sweater%20against%20a%20soft%20cream%20background%2C%20gentle%20Rembrandt%20lighting%2C%20genuine%20warm%20smile%2C%20shallow%20depth%20of%20field%2C%20clean%20minimalist%20composition%2C%20warm%20natural%20tones%2C%20professional%20yet%20approachable%20headshot&width=100&height=100&seq=testimonial-avatar-v3-t8u9&orientation=squarish"
                  alt="Customer portrait"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-foreground-900 font-semibold text-sm">Carlos M.</p>
                <p className="text-foreground-400 text-xs">Comprador Verificado</p>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5">
            <div className="bg-accent-100/50 rounded-2xl p-8 border border-accent-200/50">
              <h3 className="text-foreground-950 font-heading font-semibold text-lg mb-4">
                Nosso Compromisso com a Transpar&ecirc;ncia
              </h3>
              <ul className="space-y-4">
                {[
                  { icon: "ri-shield-check-line", text: "N&atilde;o somos afiliados ao CSSBuy oficial" },
                  { icon: "ri-lock-line", text: "N&atilde;o processamos pagamentos nem armazenamos dados" },
                  { icon: "ri-information-line", text: "Conte&uacute;do puramente informativo e educacional" },
                  { icon: "ri-user-heart-line", text: "O usu&aacute;rio assume os riscos das compras" },
                ].map((item) => (
                  <li key={item.text} className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-accent-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-accent-700 text-sm`}></i>
                    </div>
                    <span className="text-foreground-600 text-sm leading-relaxed">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}